import styled, { css } from "styled-components";
export const HXTooltipContentContainer = styled.span `
    align-self: center;
    cursor: pointer;

    ${(props) => props.stretch &&
    css `
            align-self: stretch;
        `}

    ${(props) => props.align &&
    css `
            align-self: ${props.align};
        `}
`;
